import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, MessageCircle, Sparkles } from "lucide-react";
import { BUSINESS, AREAS } from "../../data/content";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-navy text-white overflow-hidden">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="grid place-items-center w-9 h-9 rounded-lg bg-brandgreen text-white">
                <Sparkles className="w-5 h-5" strokeWidth={2.2} />
              </span>
              <span className="font-heading font-extrabold text-lg tracking-tight">
                Mark Clean Services Ltd
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Professional Domestic Cleaning &amp; Mobile Car Valeting across Preston and
              Lancashire.
            </p>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brandgreen mb-5">Quick Links</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/prices" className="hover:text-white transition-colors">Prices</Link></li>
              <li><Link to="/book" className="hover:text-white transition-colors">Book Online</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brandgreen mb-5">Areas Covered</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm text-white/70">
              {AREAS.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brandgreen mb-5">Get In Touch</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <a href={BUSINESS.phoneHref} className="flex items-center gap-2.5 hover:text-white transition-colors">
                  <Phone className="w-4 h-4 text-brandgreen" /> {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a href={BUSINESS.emailHref} className="flex items-center gap-2.5 hover:text-white transition-colors">
                  <Mail className="w-4 h-4 text-brandgreen" /> {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <MapPin className="w-4 h-4 text-brandgreen" /> {BUSINESS.location}
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              {[
                { href: BUSINESS.facebook, Icon: Facebook, label: "facebook" },
                { href: BUSINESS.instagram, Icon: Instagram, label: "instagram" },
                { href: BUSINESS.tiktok, Icon: TikTokIcon, label: "tiktok" },
                { href: BUSINESS.whatsapp, Icon: MessageCircle, label: "whatsapp" },
              ].map(({ href, Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${label}`}
                  className="grid place-items-center w-9 h-9 rounded-full bg-white/10 hover:bg-brandgreen transition-colors duration-300"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>Copyright &copy; 2026 Mark Clean Services Ltd. All rights reserved.</p>
          <Link to="/admin/login" className="hover:text-white/80 transition-colors" data-testid="admin-footer-link">
            Staff Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
